import { render, staticRenderFns } from "./PartStatusMessage.vue?vue&type=template&id=081a649e"
import script from "./PartStatusMessage.ts?vue&type=script&lang=ts&external"
export * from "./PartStatusMessage.ts?vue&type=script&lang=ts&external"
import style0 from "./PartStatusMessage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports